import { render, staticRenderFns } from "./AlternateLoanAmount.vue?vue&type=template&id=5a3ff1ee&"
import script from "./AlternateLoanAmount.vue?vue&type=script&lang=js&"
export * from "./AlternateLoanAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports